import {accessTypeEnum} from '../../lib/enum';

export default [accessTypeEnum.admin, accessTypeEnum.handlingVehicleTariff];
